import { template as template_cf05800e67b34cf1b1f7e0d52d56e7bb } from "@ember/template-compiler";
import Component from '@glimmer/component';
/**
  Renders a `<tr>` element and yields the column and cell component.
  ```hbs
  <table.thead as |head|>
    <head.row as |row|>
      <row.column @prop="firstName" as |column|>
        First name
        {{if column.isAscSorted "(sorted asc)"}}
        {{if column.isDescSorted "(sorted desc)"}}
      </row.column>
    </head.row>
  </table.thead>
  ```

  @class THeadRow
  @yield {Component} column
  @yield {Component} cell
*/ import Column from './row/column.gjs';
import Cell from './row/cell.gjs';
import { hash } from '@ember/helper';
export default class THeadRow extends Component {
    static{
        template_cf05800e67b34cf1b1f7e0d52d56e7bb(`
    <tr class='{{@trClass}} {{@theme.theadRow}} {{@theme.row}}' ...attributes>
      {{yield
        (hash
          column=(component
            Column sortable=@sortable sortSequence=@sortSequence onClick=@onColumnClick theme=@theme parent=@parent
          )
          cell=(component Cell theme=@theme parent=this columns=@columns)
        )
      }}
    </tr>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    cells = [];
    registerCell(cell) {
        let index = this.cells.length;
        this.cells.push(cell);
        return index;
    }
    unregisterCell(cell) {
        let cells = this.cells;
        let index = cells.indexOf(cell);
        cells.splice(index, 1);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3RoZWFkL3Jvdy5nanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuXG4vKipcbiAgUmVuZGVycyBhIGA8dHI-YCBlbGVtZW50IGFuZCB5aWVsZHMgdGhlIGNvbHVtbiBhbmQgY2VsbCBjb21wb25lbnQuXG4gIGBgYGhic1xuICA8dGFibGUudGhlYWQgYXMgfGhlYWR8PlxuICAgIDxoZWFkLnJvdyBhcyB8cm93fD5cbiAgICAgIDxyb3cuY29sdW1uIEBwcm9wPVwiZmlyc3ROYW1lXCIgYXMgfGNvbHVtbnw-XG4gICAgICAgIEZpcnN0IG5hbWVcbiAgICAgICAge3tpZiBjb2x1bW4uaXNBc2NTb3J0ZWQgXCIoc29ydGVkIGFzYylcIn19XG4gICAgICAgIHt7aWYgY29sdW1uLmlzRGVzY1NvcnRlZCBcIihzb3J0ZWQgZGVzYylcIn19XG4gICAgICA8L3Jvdy5jb2x1bW4-XG4gICAgPC9oZWFkLnJvdz5cbiAgPC90YWJsZS50aGVhZD5cbiAgYGBgXG5cbiAgQGNsYXNzIFRIZWFkUm93XG4gIEB5aWVsZCB7Q29tcG9uZW50fSBjb2x1bW5cbiAgQHlpZWxkIHtDb21wb25lbnR9IGNlbGxcbiovXG5cbmltcG9ydCBDb2x1bW4gZnJvbSAnLi9yb3cvY29sdW1uLmdqcyc7XG5pbXBvcnQgQ2VsbCBmcm9tICcuL3Jvdy9jZWxsLmdqcyc7XG5pbXBvcnQgeyBoYXNoIH0gZnJvbSAnQGVtYmVyL2hlbHBlcic7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFRIZWFkUm93IGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgPHRlbXBsYXRlPlxuICAgIDx0ciBjbGFzcz0ne3tAdHJDbGFzc319IHt7QHRoZW1lLnRoZWFkUm93fX0ge3tAdGhlbWUucm93fX0nIC4uLmF0dHJpYnV0ZXM-XG4gICAgICB7e3lpZWxkXG4gICAgICAgIChoYXNoXG4gICAgICAgICAgY29sdW1uPShjb21wb25lbnRcbiAgICAgICAgICAgIENvbHVtbiBzb3J0YWJsZT1Ac29ydGFibGUgc29ydFNlcXVlbmNlPUBzb3J0U2VxdWVuY2Ugb25DbGljaz1Ab25Db2x1bW5DbGljayB0aGVtZT1AdGhlbWUgcGFyZW50PUBwYXJlbnRcbiAgICAgICAgICApXG4gICAgICAgICAgY2VsbD0oY29tcG9uZW50IENlbGwgdGhlbWU9QHRoZW1lIHBhcmVudD10aGlzIGNvbHVtbnM9QGNvbHVtbnMpXG4gICAgICAgIClcbiAgICAgIH19XG4gICAgPC90cj5cbiAgPC90ZW1wbGF0ZT5cblxuICBjZWxscyA9IFtdO1xuXG4gIHJlZ2lzdGVyQ2VsbChjZWxsKSB7XG4gICAgbGV0IGluZGV4ID0gdGhpcy5jZWxscy5sZW5ndGg7XG4gICAgdGhpcy5jZWxscy5wdXNoKGNlbGwpO1xuICAgIHJldHVybiBpbmRleDtcbiAgfVxuXG4gIHVucmVnaXN0ZXJDZWxsKGNlbGwpIHtcbiAgICBsZXQgY2VsbHMgPSB0aGlzLmNlbGxzO1xuICAgIGxldCBpbmRleCA9IGNlbGxzLmluZGV4T2YoY2VsbCk7XG4gICAgY2VsbHMuc3BsaWNlKGluZGV4LCAxKTtcbiAgfVxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGVBQWUscUJBQXFCO0FBRTNDOzs7Ozs7Ozs7Ozs7Ozs7OztBQWlCQSxHQUVBLE9BQU8sWUFBWSxtQkFBbUI7QUFDdEMsT0FBTyxVQUFVLGlCQUFpQjtBQUNsQyxTQUFTLElBQUksUUFBUSxnQkFBZ0I7QUFFckMsZUFBZSxNQUFNLGlCQUFpQjtJQUNwQyxNQUFBO1FBQUEsMENBQVUsQ0FBQTs7Ozs7Ozs7Ozs7RUFXVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FYQTtJQWFWLFFBQVEsRUFBRSxDQUFDO0lBRVgsYUFBYSxJQUFJLEVBQUU7UUFDakIsSUFBSSxRQUFRLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTTtRQUM3QixJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQztRQUNoQixPQUFPO0lBQ1Q7SUFFQSxlQUFlLElBQUksRUFBRTtRQUNuQixJQUFJLFFBQVEsSUFBSSxDQUFDLEtBQUs7UUFDdEIsSUFBSSxRQUFRLE1BQU0sT0FBTyxDQUFDO1FBQzFCLE1BQU0sTUFBTSxDQUFDLE9BQU87SUFDdEI7QUFDRiJ9